"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ConfirmationPopup_1 = __importDefault(require("@Components/Popups/ConfirmationPopup"));
const Popup_1 = __importDefault(require("@Components/Popups/Popup"));
require("./index.scss");
const BulkRelinquishmentLeavePageConfirmationPopup = (props) => {
    const { onClose, onConfirm } = props;
    return (react_1.default.createElement(Popup_1.default, { className: 'bulk-overclaim-leave-page-popup', onClose: onClose },
        react_1.default.createElement(ConfirmationPopup_1.default, { title: 'Leave this page?', onCancel: onClose, cancelButtonText: 'Go back', confirmButtonText: 'Continue without saving', onConfirm: onConfirm },
            react_1.default.createElement("h4", null, "You can submit up to 100 works at a time for relinquishment"),
            "You have unsaved selections. If you leave now, your progress will be lost and you'll need to start over.")));
};
exports.default = BulkRelinquishmentLeavePageConfirmationPopup;
